import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-slate-900 text-white text-center" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="max-w-3xl mx-auto" data-id="element-14">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-15">
            No esperes a que sea tarde
          </h2>
          <p className="text-xl text-slate-300 mb-10" data-id="element-16">
            El sistema no tiene compasión, pero tú tienes el control. Protege a
            tu familia hoy por menos de lo que cuesta una cena.
          </p>

          <Button variant="primary" size="xl" className="w-full md:w-auto shadow-red-500/40 shadow-2xl" onClick={() => window.open('https://claridaddiaria.com/cart/43017627009090:1', '_blank')} data-id="element-17">
            QUIERO EL PROTOCOLO SOMBRILLA AHORA{' '}
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-18" />
          </Button>

          <p className="mt-6 text-sm text-slate-500" data-id="element-19">
            Descarga inmediata. Garantía de 30 días.
          </p>
        </div>
      </div>
    </section>;
}